// Optimized GSAP imports - only load what we need
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { SplitText } from "gsap/SplitText";

// Register plugins once
gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);

// Export optimized instances
export { gsap, ScrollTrigger, ScrollSmoother, SplitText };

// Export commonly used GSAP utilities
export const gsapUtils = {
  toArray: gsap.utils.toArray,
  matchMedia: gsap.matchMedia,
  context: gsap.context,
};
